// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3mQsX","header":"Messages_header__3v5sw"};